import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=31276c52&scoped=true&"
import script from "./DocumentEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEdit.vue?vue&type=style&index=0&id=31276c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31276c52",
  null
  
)

export default component.exports